// NPM MODULES
import React, { useState, useEffect } from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@mui/material';

import FindCustomerFormattedMessages from '../../../messages/admin/FindCustomerFormattedMessages';

// OUR COMPONENTS
import FindCustomerTableRow from '../../../components/admin/findcustomer/FindCustomerTableRow';
import AdminTableRow from '../../../components/admin/findcustomer/AdminTableRow';
import CustomerTableRow from '../../../components/admin/findcustomer/CustomerTableRow';
import EmailErrorTableRow from '../../../components/admin/findcustomer/EmailErrorTableRow';
import MessagesTableRow from '../../../components/admin/findcustomer/MessagesTableRow';
import UserTableRow from '../../../components/admin/findcustomer/UserTableRow';

const FindCustomerTable = ({ list, type, callBack }) => {
  const [sortedList, setSortedList] = useState([]);

  useEffect(() => {
    if (list) {
      const sortedAlpha = sortList(list);
      const sortedStatus =
        sortedAlpha.length > 0 && sortedAlpha[0].user_status
          ? sortByStatus(sortedAlpha)
          : sortedAlpha;
      setSortedList(sortedStatus);
    }
  }, [list]);

  const sortList = (data) => {
    return data.sort((a, b) => {
      if (a.user_name < b.user_name) {
        return -1;
      }
      if (a.user_name > b.user_name) {
        return 1;
      }
      return 0;
    });
  };

  const sortByStatus = (data) => {
    const order = ['A', 'T', 'S', 'C'];
    let newList = [];

    for (let i = 0; i < order.length; i++) {
      for (let j = 0; j < data.length; j++) {
        if (data[j].user_status === order[i]) newList.push(data[j]);
      }
    }
    for (let j = 0; j < data.length; j++) {
      if (order.indexOf(data[j].user_status) === -1) newList.push(data[j]);
    }
    return newList;
  };

  /*
    Handles when a FindCustomerTableRow is clicked on
  */
  const returnListItem = (listItemId, type, providerId, customerId) => {
    console.log('List Item click:', listItemId);
    callBack(listItemId, type, providerId, customerId);
  };

  const generateList = (type) => {
    if (type === 'ADMIN SEARCH - CUSTOMER') {
      return sortedList.map((el, index) => (
        <CustomerTableRow
          key={index}
          id={index}
          onClick={() =>
            returnListItem(el.customer_id, 'customer', el.provider_id)
          }
          onClickProvider={() => returnListItem(el.provider_id, 'provider')}
          providerName={el.provider_name}
          providerId={el.provider_id}
          customerName={el.customer_name}
          customerId={el.customer_id}
          type={el.customer_type}
          customerClass={el.customer_class}
          status={el.customer_status}
          authCode={el.auth_numbers.join()}
          domain={el.domains.join()}
          ipAddress={el.ip_addresses.join()}
        />
      ));
    } else if (type === 'ADMIN SEARCH - USER') {
      return sortedList.map((el, index) => (
        <UserTableRow
          key={index}
          id={index}
          onClick={() =>
            returnListItem(
              el.customer_user_id,
              'customer_user',
              el.provider_id,
              el.customer_id
            )
          }
          onClickCustomer={() =>
            returnListItem(el.customer_id, 'customer', el.provider_id)
          }
          onClickProvider={() => returnListItem(el.provider_id, 'provider')}
          onClickDetails={() =>
            returnListItem(
              el.customer_user_id,
              'user_report',
              el.provider_id,
              el.customer_id
            )
          }
          providerName={el.provider_name}
          customerName={el.customer_name}
          userName={el.user_name}
          email={el.user_email}
          phone={el.user_tn}
          type={el.user_type}
          userClass={el.user_class}
          status={el.user_status}
          softwareRelease={el.sw_release}
        />
      ));
    } else if (type === 'ADMIN SEARCH - ADMIN') {
      return sortedList.map((el, index) => (
        <AdminTableRow
          key={index}
          id={index}
          onClickCustomer={() =>
            returnListItem(el.customer_id, 'customer', el.provider_id)
          }
          onClickContact={() =>
            returnListItem(
              el.customer_contact_id,
              'admin_contact',
              el.provider_id,
              el.customer_id
            )
          }
          providerName={el.provider_name}
          customerName={el.customer_name}
          contactName={el.contact_name}
          contactEmail={el.contact_email}
          contactPhone={el.contact_tn}
          contactDepartment={el.contact_dept}
          accessLevel={el.access_level}
        />
      ));
    } else if (type === 'ADMIN SEARCH - EMAIL ERROR') {
      return sortedList.map((el, index) => {
        let bodyText;
        try {
          bodyText = decodeURIComponent(el.email_text);
        } catch (err) {
          bodyText = 'ERROR: MALFORMED TEXT';
        }
        return (
          <EmailErrorTableRow
            key={index}
            id={index}
            onClick={() =>
              returnListItem(el.customer_user_id, 'email_recipient')
            }
            providerName={el.provider_name}
            customerName={el.customer_name}
            type={el.customer_type}
            customerClass={el.customer_class}
            status={el.customer_status}
            destEmail={el.dest_email}
            body={bodyText}
          />
        );
      });
    } else if (type === 'ADMIN SEARCH - MESSAGES VIA DESTINATION') {
      return sortedList.map((el, index) => (
        <MessagesTableRow
          key={index}
          id={index}
          providerName={el.provider_name}
          customerName={el.customer_name}
          userName={el.user_name}
          email={el.user_email}
          phone={el.dest_tn}
        />
      ));
    } else {
      return list.map((element, index) => (
        <FindCustomerTableRow
          key={element.customer_user_id}
          onClick={() => returnListItem(element.customer_user_id)}
          name={element.user_name}
          email={element.user_email}
          number={element.user_tn}
          status={element.user_status}
          msgmax={element.max_sms_per_day}
          centre={element.cost_centre_title}
        />
      ));
    }
  };

  return (
    <TableContainer
      sx={{ marginBottom: 4, overflowX: 'auto', whiteSpace: 'nowrap' }}
    >
      <Table id="inbox">
        <TableHead>
          <TableRow key="head">
            {type === 'ADMIN SEARCH - CUSTOMER' && (
              <>
                <TableCell>
                  {FindCustomerFormattedMessages.providerName}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.customerName}
                </TableCell>
                <TableCell>{FindCustomerFormattedMessages.type}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.class}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.status}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.authCode}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.domain}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.ipAddress}</TableCell>
              </>
            )}
            {type === 'ADMIN SEARCH - USER' && (
              <>
                <TableCell>
                  {FindCustomerFormattedMessages.providerName}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.customerName}
                </TableCell>
                <TableCell>{FindCustomerFormattedMessages.userName}</TableCell>
                <TableCell></TableCell>
                <TableCell>{FindCustomerFormattedMessages.userEmail}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.userPhone}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.type}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.class}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.status}</TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.softVersion}
                </TableCell>
              </>
            )}
            {type === 'ADMIN SEARCH - ADMIN' && (
              <>
                <TableCell>
                  {FindCustomerFormattedMessages.providerName}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.customerName}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.contactName}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.contactEmail}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.contactPhone}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.contactDepartment}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.accessLevel}
                </TableCell>
              </>
            )}
            {type === 'ADMIN SEARCH - EMAIL ERROR' && (
              <>
                <TableCell>
                  {FindCustomerFormattedMessages.providerName}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.customerName}
                </TableCell>
                <TableCell>{FindCustomerFormattedMessages.type}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.class}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.status}</TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.destinationEmail}
                </TableCell>
                <TableCell>{FindCustomerFormattedMessages.body}</TableCell>
              </>
            )}
            {type === 'ADMIN SEARCH - MESSAGES VIA DESTINATION' && (
              <>
                <TableCell>
                  {FindCustomerFormattedMessages.providerName}
                </TableCell>
                <TableCell>
                  {FindCustomerFormattedMessages.customerName}
                </TableCell>
                <TableCell>{FindCustomerFormattedMessages.userName}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.email}</TableCell>
                <TableCell>{FindCustomerFormattedMessages.phone}</TableCell>
              </>
            )}
            {type !== 'ADMIN SEARCH - CUSTOMER' &&
              type !== 'ADMIN SEARCH - USER' &&
              type !== 'ADMIN SEARCH - ADMIN' &&
              type !== 'ADMIN SEARCH - EMAIL ERROR' &&
              type !== 'ADMIN SEARCH - MESSAGES VIA DESTINATION' && (
                <>
                  <TableCell>{FindCustomerFormattedMessages.name}</TableCell>
                  <TableCell>{FindCustomerFormattedMessages.email}</TableCell>
                  <TableCell>{FindCustomerFormattedMessages.cell}</TableCell>
                  <TableCell>{FindCustomerFormattedMessages.status}</TableCell>
                  <TableCell>
                    {FindCustomerFormattedMessages.maxDailyMessage}
                  </TableCell>
                  <TableCell>
                    {FindCustomerFormattedMessages.costCenter}
                  </TableCell>
                </>
              )}
          </TableRow>
        </TableHead>
        <TableBody>{generateList(type)}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default FindCustomerTable;
